import { RootStore } from "store/root.store";

export default new RootStore();
